

























































import { defineComponent, ref, Ref } from '@vue/composition-api'
import { useAuth } from '@/composables/useAuth'
import { useRouter } from '@u3u/vue-hooks'

// @vue/component
export default defineComponent({
  setup(_, { root }) {
    const { login: loginBase, isLoggedIn } = useAuth()
    const username: Ref<string | null> = ref(null)
    const password: Ref<string | null> = ref(null)

    const { router } = useRouter()
    const login = () => {
      if (username.value && password.value) {
        loginBase(username.value, password.value)
        if (isLoggedIn.value) {
          router.push('/')
          return
        }
      }
      root.$notification.error({
        message: 'Failed to login',
        description: 'An error occurred'
      })
    }

    return {
      login,
      username,
      password
    }
  }
})
